import React from 'react';

import PropTypes from 'prop-types';
import { Form, Checkbox, Header } from 'semantic-ui-react';

import _get from 'lodash/get';

import FormDestinationEmail from 'components/modules/custom-pages/components/EditPageElementModal/components/EditFormBlock/components/FormDestinationEmail';
import { DEFAULT_DESTINATION_EMAIL_MESSAGE } from 'components/modules/custom-pages/components/EditPageElementModal/components/EditFormBlock/components/FormDestinationEmail/FormDestinationEmail.constants';

import { NotificationSettingsPropType } from './NotificationSettings.types';

import './NotificationSettings.scss';

const propTypes = {
  settings: NotificationSettingsPropType.isRequired,
  onChange: PropTypes.func.isRequired,
};

const defaultProps = {};

export default function NotificationSettings({ settings, onChange }) {
  const channels = _get(settings, 'channels', {});
  const emailSettings = _get(channels, 'email', {});
  const emailEnabled = _get(emailSettings, 'enabled', false);
  const emailDestinations = _get(emailSettings, 'destinations', []);

  function onEmailSettingsChange(newSettings) {
    onChange('channels', {
      ...channels,
      email: { ...emailSettings, ...newSettings },
    });
  }

  function onEmailToggle(checked) {
    onEmailSettingsChange({ enabled: checked });
  }

  return (
    <div className="notification-settings">
      <Header as="h4">Notification Settings</Header>
      <div className="email-settings">
        <Form.Field style={{ marginBottom: 12, display: 'flex', alignItems: 'center' }}>
          <Checkbox
            toggle
            label="Email Notifications"
            checked={emailEnabled}
            onChange={(e, { checked }) => onEmailToggle(checked)}
            style={{ marginRight: 8 }}
          />
        </Form.Field>
        {emailEnabled && (
          <Form.Field style={{ marginBottom: 0 }}>
            <FormDestinationEmail
              label="Contact Email Destinations"
              noEmailsHelpMessage={DEFAULT_DESTINATION_EMAIL_MESSAGE}
              selectedEmails={emailDestinations}
              onChange={(newEmails) => onEmailSettingsChange({ destinations: newEmails })}
            />
          </Form.Field>
        )}
      </div>
    </div>
  );
}

NotificationSettings.propTypes = propTypes;
NotificationSettings.defaultProps = defaultProps;
